import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { RootState } from '../../modules';
import {
  setSearchKeyword,
  searchKeywordState,
} from '../../modules/searchKeyword';

import SearchInputForm from '../../components/common/SearchInputForm';
import {
  tabResultState,
  setIsMoreInfoResult,
  setIsMoreInfoAttachment,
  setSearchDataNull,
  getSearchAsync,
  getRelatedWordAsync,
  getPopularKeywordAsync,
  getWikiAsync,
  getSpellCheckerAsync,
  getSearchImageAsync,
  getSearchAttachmentAsync,
} from '../../modules/tabResult';
import {
  tabImageState,
  setIsDetailViewOpen,
  setImageDataNull,
  setAddImage,
  getSearchImageAsyncInImageTab,
} from '../../modules/tabImage';
import {
  tabAIState,
  setIsMoreInfoPath0,
  setIsMoreInfoPath1,
  setIsMoreInfoPath2,
  setIsMoreInfoPathAttach1,
  setIsMoreInfoPathAttach0,
  setAIDataNull,
  setIsMoreInfoPathAttach2,
  getPathNetworkRecommend2Async,
  getPatentAsync,
  getRecommendedWordAsync,
} from '../../modules/tabAI';
import {
  goToResult,
  goToAI,
  goToImage,
  goToSimilarImage,
} from '../../modules/tabMenu';
import {
  GetSearchParamType,
  GetPopularKeywordParamType,
  GetWikiParamType,
  GetRelatedWordParamType,
  GetSpellCheckerParamType,
  GetSearchImageParamType,
  GetSearchAttachParamType,
} from '../../lib/tabResult/type';
import { GetPathNetworkRecommendParamType2 } from '../../lib/tabAI/recommendType';
import {
  GetPatentParamType,
  GetRecommendedWordParamType,
} from '../../lib/tabAI/type';
import { GetSearchImageParamInImageTabType } from '../../lib/tabImage/type';
import { GetSimilarImageParamType } from '../../lib/tabSimilarImage/type';
import {
  getSimilarImageAsync,
  setSimilarImageDataNull,
} from '../../modules/tabSimilarImage';

interface SearchInputContainerProps {
  urlParam: string;
}
function SearchInputContainer({ urlParam }: SearchInputContainerProps) {
  const { searchKeyword } = useSelector(
    (state: RootState) => state.searchKeyword
  );
  const dispatch = useDispatch();

  // 검색어 저장
  const onSetSearchKeyword = (
    searchKeyword: searchKeywordState['searchKeyword']
  ) => {
    dispatch(setSearchKeyword(searchKeyword));
  };

  // 검색결과 탭에서 상세보기
  const onSetIsMoreInfoResult = (
    isMoreInfoResult: tabResultState['isMoreInfoResult']
  ) => {
    dispatch(setIsMoreInfoResult(isMoreInfoResult));
  };
  const onSetIsMoreInfoAttachment = (
    isMoreInfoAttach: tabResultState['isMoreInfoAttach']
  ) => {
    dispatch(setIsMoreInfoAttachment(isMoreInfoAttach));
  };

  // 이미지 탭에서 상세보기
  const onSetIsDetailViewOpen = (
    isDetailViewOpen: tabImageState['isDetailViewOpen']
  ) => {
    dispatch(setIsDetailViewOpen(isDetailViewOpen));
  };

  // 추천결과 탭에서 상세보기
  const onSetIsMoreInfoPath0 = (
    isMoreInfoPath0: tabAIState['isMoreInfoPath0']
  ) => {
    dispatch(setIsMoreInfoPath0(isMoreInfoPath0));
  };
  const onSetIsMoreInfoPath1 = (
    isMoreInfoPath1: tabAIState['isMoreInfoPath1']
  ) => {
    dispatch(setIsMoreInfoPath1(isMoreInfoPath1));
  };
  const onSetIsMoreInfoPath2 = (
    isMoreInfoPath2: tabAIState['isMoreInfoPath2']
  ) => {
    dispatch(setIsMoreInfoPath2(isMoreInfoPath2));
  };
  const onSetIsMoreInfoPathAttach0 = (
    isMoreInfoPathAttach0: tabAIState['isMoreInfoPathAttach0']
  ) => {
    dispatch(setIsMoreInfoPathAttach0(isMoreInfoPathAttach0));
  };
  const onSetIsMoreInfoPathAttach1 = (
    isMoreInfoPathAttach1: tabAIState['isMoreInfoPathAttach1']
  ) => {
    dispatch(setIsMoreInfoPathAttach1(isMoreInfoPathAttach1));
  };
  const onSetIsMoreInfoPathAttach2 = (
    isMoreInfoPathAttach2: tabAIState['isMoreInfoPathAttach2']
  ) => {
    dispatch(setIsMoreInfoPathAttach2(isMoreInfoPathAttach2));
  };

  // 검색결과 탭에서 검색할때 호출하는 api
  const onGetSearch = (info: GetSearchParamType) => {
    dispatch(getSearchAsync.request(info));
  };
  const onGetSearchImage = (info: GetSearchImageParamType) => {
    onSetIsDetailViewOpen(false);
    dispatch(getSearchImageAsync.request(info));
  };
  const onGetRelatedWord = (info: GetRelatedWordParamType) => {
    dispatch(getRelatedWordAsync.request(info));
  };
  const onGetPopularKeyword = (info: GetPopularKeywordParamType) => {
    dispatch(getPopularKeywordAsync.request(info));
  };
  const onGetWiki = (info: GetWikiParamType) => {
    dispatch(getWikiAsync.request(info));
  };
  const onGetSpellChecker = (info: GetSpellCheckerParamType) => {
    dispatch(getSpellCheckerAsync.request(info));
  };
  const onGetSearchAttach = (info: GetSearchAttachParamType) => {
    dispatch(getSearchAttachmentAsync.request(info));
  };
  const onResultSearchRelatedApi = (
    infoSearch: GetSearchParamType,
    infoSearchImage: GetSearchImageParamType,
    infoSearchAttach: GetSearchAttachParamType,
    infoRelated: GetRelatedWordParamType,
    infoPopular: GetPopularKeywordParamType,
    infoWiki: GetWikiParamType,
    infoSpellChecker: GetSpellCheckerParamType
  ) => {
    onGetSearch(infoSearch);
    onGetSearchImage(infoSearchImage);
    onGetSearchAttach(infoSearchAttach);
    onGetRelatedWord(infoRelated);
    onGetPopularKeyword(infoPopular);
    onGetWiki(infoWiki);
    onGetSpellChecker(infoSpellChecker);
    onSetIsMoreInfoResult(false);
    onSetIsMoreInfoAttachment(false);
  };

  // AI 탭에서 검색할 때 호출하는 api
  const onGetPathNetwork2 = (info: GetPathNetworkRecommendParamType2) => {
    onSetIsMoreInfoPath0(false);
    onSetIsMoreInfoPath1(false);
    onSetIsMoreInfoPath2(false);
    onSetIsMoreInfoPathAttach0(false);
    onSetIsMoreInfoPathAttach1(false);
    onSetIsMoreInfoPathAttach2(false);
    dispatch(getPathNetworkRecommend2Async.request(info));
  };
  const onGetPatent = (info: GetPatentParamType) => {
    dispatch(getPatentAsync.request(info));
  };
  const onGetRecommendedWord = (info: GetRecommendedWordParamType) => {
    dispatch(getRecommendedWordAsync.request(info));
  };

  // 이미지 탬에서 검색할 때 호출하는 api
  const onGetSearchImageInImageTab = (
    info: GetSearchImageParamInImageTabType
  ) => {
    onSetIsDetailViewOpen(false);
    dispatch(getSearchImageAsyncInImageTab.request(info));
  };
  const onSetAddImage = (addImageData: tabImageState['addImageData']) => {
    dispatch(setAddImage(addImageData));
  };

  // 유사이미지 검색 api
  const onGetSimilarImage = (info: GetSimilarImageParamType) => {
    dispatch(getSimilarImageAsync.request(info));
  };

  // 탭 이동 및 데이터 null 셋팅
  const onSetSearchDataNull = () => {
    dispatch(setSearchDataNull());
  };
  const onSetAIDataNull = () => {
    dispatch(setAIDataNull());
  };
  const onSetImageDataNull = () => {
    dispatch(setImageDataNull());
  };
  const onSetSimilarImageDataNull = () => {
    dispatch(setSimilarImageDataNull());
  };

  const onGoToResult = (q: string | string[]) => {
    dispatch(goToResult(q));
    onResultSearchRelatedApi(
      {
        page: 1,
        page_count: 5,
        session: localStorage.getItem('aivory_session_id') || 'test_session',
        targets: 'travel_info,recommended_info,course_info',
        query: q,
        type: localStorage.getItem('aivory_option_sort') || '0',
        search_option: localStorage.getItem('aivory_option_result') || '',
        start_date: localStorage.getItem('aivory_option_date_start') || '',
        end_date: localStorage.getItem('aivory_option_date_end') || '',
      },
      {
        page: 1,
        page_count: 5,
        targets: 'travel_info,recommended_info,course_info',
        query: q,
        type: localStorage.getItem('aivory_option_sort') || '0',
      },
      {
        page: 1,
        page_count: 5,
        query: q,
        targets: 'travel_info,recommended_info,course_info',  //헷갈림
        type: localStorage.getItem('aivory_option_sort') || '0',
        start_date: localStorage.getItem('aivory_option_date_start') || '',
        end_date: localStorage.getItem('aivory_option_date_end') || '',
      },
      { word: q },
      { date_unit: 'week', count: 10 },
      { query: q },
      { word: q }
    );

    onSetIsMoreInfoResult(false);
    onSetIsMoreInfoAttachment(false);
    onSetIsDetailViewOpen(false);

    onSetIsMoreInfoPath0(false);
    onSetIsMoreInfoPath1(false);
    onSetIsMoreInfoPath2(false);
    onSetIsMoreInfoPathAttach0(false);
    onSetIsMoreInfoPathAttach1(false);
    onSetIsMoreInfoPathAttach2(false);
    onSetAIDataNull();
    onSetImageDataNull();
    onSetSimilarImageDataNull();
  };

  const onGoToAI = (q: string | string[]) => {
    dispatch(goToAI(q));
    onGetPathNetwork2({
      session: localStorage.getItem('aivory_session_id') || 'test_session',
      date_unit: 'month',
      total_count: 40,
      query: q,
    });
    onGetPatent({
      query: q,
    });
    onGetRecommendedWord({
      word: q,
    });

    onSetIsMoreInfoResult(false);
    onSetIsMoreInfoAttachment(false);
    onSetIsDetailViewOpen(false);

    onSetIsMoreInfoPath0(false);
    onSetIsMoreInfoPath1(false);
    onSetIsMoreInfoPath2(false);
    onSetIsMoreInfoPathAttach0(false);
    onSetIsMoreInfoPathAttach1(false);
    onSetIsMoreInfoPathAttach2(false);
    onSetSearchDataNull();
    onSetImageDataNull();
    onSetSimilarImageDataNull();
  };

  const onGoToImage = (q: string | string[]) => {
    dispatch(goToImage(q));

    onGetSearchImageInImageTab({
      page: 1,
      page_count: 40,
      targets: 'travel_info,recommended_info,course_info',
      query: q,
      type: localStorage.getItem('aivory_option_sort') || '0',
    });
    onSetAddImage([]);

    onSetIsMoreInfoResult(false);
    onSetIsMoreInfoAttachment(false);
    onSetIsDetailViewOpen(false);

    onSetIsMoreInfoPath0(false);
    onSetIsMoreInfoPath1(false);
    onSetIsMoreInfoPath2(false);
    onSetIsMoreInfoPathAttach0(false);
    onSetIsMoreInfoPathAttach1(false);
    onSetIsMoreInfoPathAttach2(false);
    onSetSearchDataNull();
    onSetAIDataNull();
    onSetSimilarImageDataNull();
  };

  const onGoToSimilarImage = (q: string | string[]) => {
    onSetSearchKeyword(q);
    dispatch(goToSimilarImage(q));

    onSetIsMoreInfoResult(false);
    onSetIsMoreInfoAttachment(false);
    onSetIsDetailViewOpen(false);

    onSetIsMoreInfoPath0(false);
    onSetIsMoreInfoPath1(false);
    onSetIsMoreInfoPath2(false);
    onSetIsMoreInfoPathAttach0(false);
    onSetIsMoreInfoPathAttach1(false);
    onSetIsMoreInfoPathAttach2(false);

    onSetSearchDataNull();
    onSetAIDataNull();
    onSetImageDataNull();
  };

  return (
    <SearchInputForm
      onSetSearchKeyword={onSetSearchKeyword}
      onGoToResult={onGoToResult}
      onGoToAI={onGoToAI}
      onGoToImage={onGoToImage}
      onGoToSimilarImage={onGoToSimilarImage}
      onGetSimilarImage={onGetSimilarImage}
      searchKeyword={searchKeyword}
      urlParam={urlParam}
    />
  );
}

export default SearchInputContainer;
